import { render, staticRenderFns } from "./ProdEditPlmtrl.vue?vue&type=template&id=6768c5fc&scoped=true&"
import script from "./ProdEditPlmtrl.vue?vue&type=script&lang=js&"
export * from "./ProdEditPlmtrl.vue?vue&type=script&lang=js&"
import style0 from "./ProdEditPlmtrl.vue?vue&type=style&index=0&id=6768c5fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768c5fc",
  null
  
)

export default component.exports